import { Device } from "@core/models/domain/device.domain";
import { DeviceRegistrationRequest } from "@core/models/request/device.request";
import {createAction, props} from "@ngrx/store";

// LOAD DEVICES
export const loadDevices = createAction('[Device] Load Devices');
// Store-first variant: only triggers loadDevices when the cache is empty, stale or invalidated.
export const loadDevicesIfNeeded = createAction('[Device] Load Devices If Needed');
export const loadDevicesSuccess = createAction(
  "[Device] Load Devices Success",
  props<{ devices: Device[] }>()
);
export const loadDevicesFailure = createAction(
  "[Device] Load Devices Failure",
  props<{ error: any }>()
);

// REGISTER DEVICE
export const registerDevices = createAction(
  "[Device] Register Devices",
  props<{ request: DeviceRegistrationRequest }>()
);
export const registerDevicesSuccess = createAction(
  "[Device] Register Devices Success",
  props<{ devices: Device[] }>()
);
export const registerDevicesFailure = createAction(
    '[Device] Register Devices Failure',
    props<{ error: any }>()
);

// DELETE DEVICE
export const removeDevice = createAction(
    '[Device] Remove Device',
    props<{ deviceId: string }>()
);
export const RemoveDeviceSuccess = createAction(
    '[Device] Remove Device Success',
    props<{ deviceId: string }>()
);
export const removeDeviceFailure = createAction(
    '[Device] Remove Device Failure',
    props<{ error: any }>()
);